import { render, staticRenderFns } from "./TemplateNameModal.vue?vue&type=template&id=600d8304&scoped=true&"
import script from "./TemplateNameModal.vue?vue&type=script&lang=js&"
export * from "./TemplateNameModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateNameModal.vue?vue&type=style&index=0&id=600d8304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600d8304",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600d8304')) {
      api.createRecord('600d8304', component.options)
    } else {
      api.reload('600d8304', component.options)
    }
    module.hot.accept("./TemplateNameModal.vue?vue&type=template&id=600d8304&scoped=true&", function () {
      api.rerender('600d8304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ImportMappings/TemplateNameModal.vue"
export default component.exports